import {
    DesvincularTemplateModuloService,
    DesvincularTemplateModulosService,
    GetTemplatesDesvinculadosPorModulosServices,
    GetTemplatesPorModulosServices,
    GetTemplatesServices,
    ListarDocumentoTemplateModuloService,
    VincularModulosAoTemplateService,
    VincularTemplateModuloTelaService,
} from "../../../Services/Geral/TemplatesModulo/TemplatesModuloServices";
import { Controller } from "../../Controller";

export async function GetTemplatesPorModulosController(idTipoCaso: number) {
    return Controller(GetTemplatesPorModulosServices(idTipoCaso));
}

export async function GetTemplatesComFlagController(
    idTipoCaso: number,
    flNaoCarregaTemplate: boolean
) {
    return Controller(GetTemplatesServices(idTipoCaso, flNaoCarregaTemplate));
}

export async function GetTemplatesDesvinculadosPorModulosController(
    idModulo: number
) {
    return Controller(GetTemplatesDesvinculadosPorModulosServices(idModulo));
}

export async function DesvincularTemplateModuloController(
    idDocumentoTemplateModulo: number[]
) {
    return Controller(
        DesvincularTemplateModuloService(idDocumentoTemplateModulo)
    );
}

export async function VincularTemplateModuloController(
    idTipoCaso: number,
    idDocumentoTemplate: number[]
) {
    return Controller(
        VincularTemplateModuloTelaService(idTipoCaso, idDocumentoTemplate)
    );
}

export const GetTemplatesController = async () =>
    GetTemplatesComFlagController(0, true);

export async function ListarDocumentoTemplateModuloController(
    idDocumentoTemplate: number
) {
    return Controller(
        ListarDocumentoTemplateModuloService(idDocumentoTemplate)
    );
}

export async function VincularModulosAoTemplateController(
    idDocumentoTemplate: number,
    requestBody: Array<number>
) {
    return Controller(
        VincularModulosAoTemplateService(idDocumentoTemplate, requestBody)
    );
}

export async function DesvincularTemplateModulosController(
    idDocumentoTemplate: number,
    requestBody: Array<number>
) {
    return Controller(
        DesvincularTemplateModulosService(idDocumentoTemplate, requestBody)
    );
}
